export default {
    name: "qdList",
    data: function() {
        return {
            tab: '',
            list: [],
            showTips: false,
            Page: 1,
            Length: 10,
            total: 0,
            ServantName: this.$route.query.ServantName
        }
    },
    methods: {
        getList: function() {
            var _this = this;
            this.$post("/servant/getlistjob", {
                JobType: this.$route.query.jobType,
                ServantId: this.$route.query.id || '',
                CityId: this.$getCity() || '',
                ProfileStoreId: this.$getProfileStoreId() || '',
                Page: this.Page,
                Length: this.Length
            }, function(res) {
                _this.list = _this.list.concat(res.ListJob);
                _this.total = Math.ceil(res.TotalCount / _this.Length);
                _this.Page++;
                if (res.ListJob.length == 0) {
                    _this.showTips = true;
                } else {
                    _this.showTips = false;
                }
            })
        },
        nextPage: function() {
            if (this.Page < this.total) {
                this.getList();
            }
        },
        recommend: function(job) { //jobId, jobTypeStr

            //TODO remove
            var jobTypeObj = {
                "临时保洁": 1,
                "长期钟点工": 2,
                "全天保姆": 3,
                "住家保姆": 4,
                "月嫂": 5,
                "育婴师": 6,
                "催乳师": 7,
                "专业除螨": 8,
                "早出晚归": 9,
                "其他": 99
            };
            var jobType = jobTypeObj[job.JobTypeStr] || 1;
            window.sessionStorage.setItem("curr_job", JSON.stringify({
                JobId: job.JobId,
                JobTypeStr: job.JobTypeStr,
                SalaryRange: job.SalaryRange,
                SalaryRangeUnit: job.SalaryRangeUnit
            }));

            this.$router.push({
                name: "salary",
                query: {
                    JobId: job.JobId,
                    ServantAccountCode: this.$route.query.AccountCode,
                    ProfileStoreId: this.$route.query.ProfileStoreId,
                    ServantName: this.$route.query.ServantName
                }
            });
        },
        checkTab: function(str) {
            this.tab = (this.tab == str ? '' : str);
            this.Page = 1;
            this.list = [];
            this.getList();
        },
        showJob: function(job) {
            window.sessionStorage.setItem("curr_job", JSON.stringify({
                JobId: job.JobId,
                JobTypeStr: job.JobTypeStr,
                SalaryRange: job.SalaryRange,
                SalaryRangeUnit: job.SalaryRangeUnit
            }));
            this.$router.push({ name: "jobDetail", query: { id: job.JobId } })
        }
    },
    mounted: function() {
        this.getList();
    }
}


// WEBPACK FOOTER //
// ./src/ally/page/server/matchJob.js